<template>
  <el-dialog :visible.sync="dialog" width="80%">
    <span slot="title" class="dialog-footer">
      <h3>{{ ruleForm.subject }}&nbsp;<small>Enviada em {{ ruleForm.createdAt }}</small></h3>
    </span>
    <vue-editor ref="vEditor" :editorOptions="{ modules: { toolbar: false } }" :read-only="true" :disabled="false"
      v-model="ruleForm.messageHtml"></vue-editor>
    <span slot="footer" class="dialog-footer">
      <el-button type="default" @click="toggle">OK</el-button>
      <el-button type="primary" v-if="hasPrevious" @click="previous">Anterior</el-button>
      <el-button type="primary" v-if="hasNext" @click="next">Próximo</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { VueEditor } from "vue2-editor";
import { NotificationService } from "@/services/comum/notification.services";

export default {
  components: { VueEditor },
  data: function () {
    return {
      tableData: [],
      current: 0,
      ruleForm: {
        id: null,
        createdAt: '',
        sendedBy: '',
        subject: '',
        message: "",
        highlight: false,
      },
      dialog: false,
    };
  },
  computed: {
    hasPrevious() {
      return this.current > 0;
    },
    hasNext() {
      return this.current < this.tableData.length - 1;
    }
  },
  methods: {
    previous() {
      const vm = this;
      const next = vm.current - 1;
      if (vm.tableData[next]) {
        vm.current = next;
        vm.ruleForm = vm.tableData[next];
        if (!vm.tableData[next].read) this.$bus.$emit("readMessage", 'subtract', 1);
        NotificationService.read([vm.ruleForm.id], true);
        vm.tableData[next].read = true;
      }
    },
    next() {
      const vm = this;
      const next = vm.current + 1;
      if (vm.tableData[next]) {
        vm.current = next;
        vm.ruleForm = vm.tableData[next];
        if (!vm.tableData[next].read) this.$bus.$emit("readMessage", 'subtract', 1);
        vm.tableData[next].read = true;
        NotificationService.read([vm.ruleForm.id], true);
      }
    },
    open() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      NotificationService.list(10, 1, 2, 1)
        .then((response) => {
          vm.tableData = response;
          if (response.length > 0) {
            vm.ruleForm = response[0];
            NotificationService.read([vm.ruleForm.id], true);
            vm.current = 0;
            if (!vm.tableData[vm.current].read) this.$bus.$emit("readMessage", 'subtract', 1);
            vm.dialog = true;
          }
        })
        .catch((error) => {
          this.$message({
            type: "error",
            duration: 5000,
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    toggle() {
      this.ruleForm.id = '';
      this.ruleForm.sendedBy = '';
      this.ruleForm.subject = '';
      this.ruleForm.message = '';
      this.dialog = false;
    },
  },
};
</script>
<style>
small {
  font-size: 11px;
}
</style>